/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutNotificationDetails } from './rolloutNotificationDetails';
import { RolloutActionResponse } from './rolloutActionResponse';
import { RolloutActionState } from './rolloutActionState';
import { RolloutActionType } from './rolloutActionType';
import { RolloutTaskDetails } from './rolloutTaskDetails';


export interface RolloutTaskActionResponse extends RolloutActionResponse { 
    /**
     * Created user email ID.
     */
    created_by?: string;
    /**
     * Created Date Time
     */
    created_ts?: Date;
    /**
     * Updated user email ID.
     */
    updated_by?: string;
    /**
     * Updated Date Time
     */
    updated_ts?: Date;
    task?: RolloutTaskDetails;
    /**
     * List of notifications.
     */
    notifications?: Array<RolloutNotificationDetails>;
}
export namespace RolloutTaskActionResponse {
}


